import { toDateTime } from "Utils/dateTime";
const parseDate = (stringDate) => {
    if (stringDate) {
        const luxonDate = toDateTime(stringDate);
        if (luxonDate.isValid) {
            return luxonDate.toJSDate();
        }
    }
    return undefined;
};
const compareDate = (date1, date2) => {
    if (!date1 && !date2) {
        return 0;
    }
    if (!date1) {
        return 1;
    }
    if (!date2) {
        return -1;
    }
    if (date1 < date2) {
        return -1;
    }
    if (date1 > date2) {
        return 1;
    }
    return 0;
};
export const sortingDataTime = (dataTime1, dataTime2) => {
    const date1 = parseDate(dataTime1);
    const date2 = parseDate(dataTime2);
    return compareDate(date1, date2);
};
